var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 513,
    height: 223,
    viewBox: "0 0 513 223",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1017 -370)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 223,
    transform: "translate(1017 370)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1103.004 419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.1,125H220.8a1,1,0,0,1-1-1V60.6a1,1,0,0,1,1-1h11.3a1,1,0,0,1,1,1V124A1,1,0,0,1,232.1,125Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.4,72.9a19.45,19.45,0,0,1,.1,38.9h-.1a19.45,19.45,0,0,1-.1-38.9h.1m0-13.3h-.2a32.7,32.7,0,0,0,.2,65.4h.2a32.7,32.7,0,0,0-.2-65.4Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.4,109.3a18.68,18.68,0,0,1-9.3,2.4H134a19.477,19.477,0,0,1-19.1-23,20.586,20.586,0,0,1,3.1-7.5,19.1,19.1,0,0,1,15.8-8.3h.1a19.379,19.379,0,0,1,17.2,10.5.752.752,0,0,0,.7.5h12.5a.8.8,0,0,0,.8-1.1,32.828,32.828,0,0,0-31.3-23.2h-.2a32.7,32.7,0,0,0,.2,65.4h.2a32.7,32.7,0,0,0,31.1-23.3.878.878,0,0,0-.8-1.1H151.8a.752.752,0,0,0-.7.5A18.391,18.391,0,0,1,143.4,109.3Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,27.3h-8.9a.645.645,0,0,0-.6.6V50.2a.645.645,0,0,0,.6.6h3.6a.645.645,0,0,0,.6-.6V42h4.6a7.3,7.3,0,0,0,7.3-7.4A7.192,7.192,0,0,0,288,27.3Zm0,10h-4.7V32.1h4.6a2.6,2.6,0,0,1,.1,5.2Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.1,34.6a7.341,7.341,0,0,0-7.3-7.3H299a.645.645,0,0,0-.6.6V50.2a.645.645,0,0,0,.6.6h3.6a.645.645,0,0,0,.6-.6V42h0l6.1,8.7h5.8l-6.2-8.8A7.34,7.34,0,0,0,315.1,34.6Zm-7.3-2.5a2.647,2.647,0,0,1,2.6,2.6,2.582,2.582,0,0,1-2.6,2.6h-4.7V32.1Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.8,32.1a6.95,6.95,0,0,1,.1,13.9h0a7.066,7.066,0,0,1-7-6.9,6.8,6.8,0,0,1,2-4.9,6.355,6.355,0,0,1,4.9-2.1h0m0-4.8h0a11.75,11.75,0,0,0,0,23.5h.1A11.737,11.737,0,0,0,341.6,39a11.866,11.866,0,0,0-11.8-11.7Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7,27.3H.7c-.7,0-.9.5-.5,1L81,124.6a1.159,1.159,0,0,0,1,.4h24a.634.634,0,0,0,.5-1L25.7,27.8A1.389,1.389,0,0,0,24.7,27.3Z",
    fill: "#e52c4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.4,0,.6,123.9A.626.626,0,0,0,1,125H32a1.777,1.777,0,0,0,1-.4L137.4,0",
    fill: "#e52c4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.7,111.4h-.1a18.724,18.724,0,0,1-7.1-1.4,19.165,19.165,0,0,1-9.9-8.9,18.634,18.634,0,0,1-2.3-9.1,19.418,19.418,0,0,1,19.3-19.5h.1a20.537,20.537,0,0,1,9.2,2.3,19.955,19.955,0,0,1,8.9,9.9l9.4-9.4a.769.769,0,0,0,.1-1,32.829,32.829,0,0,0-8.7-9.1,32.145,32.145,0,0,0-18.8-6h-.2a32.7,32.7,0,0,0,.2,65.4h.2a32.892,32.892,0,0,0,24.9-11.7.792.792,0,0,0-.1-1.1l-8.5-8a.817.817,0,0,0-1.2.1A20.137,20.137,0,0,1,313.7,111.4Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.6,113.2l-6.7-6.7a2,2,0,0,1,0-2.7l35.4-35.4a2,2,0,0,1,2.7,0l6.7,6.7a2,2,0,0,1,0,2.7l-35.4,35.4A2,2,0,0,1,300.6,113.2Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.7,125H242.4a.945.945,0,0,1-1-1V60.6a1,1,0,0,1,1-1h11.3a1,1,0,0,1,1,1V124A1,1,0,0,1,253.7,125Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.2,75.1h.1a20.47,20.47,0,0,1,8.2.5.806.806,0,0,0,.9-.3l7.2-9.8a.889.889,0,0,0-.3-1.3,32.821,32.821,0,0,0-17.9-2.4h-.2A32.467,32.467,0,0,0,248.1,71L252,97h0A19.264,19.264,0,0,1,268.2,75.1Z",
    fill: "#333"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ba5050bba9e60def2917959e4a7ca7f5.svg";
export { ForwardRef as ReactComponent };